'use strict';
let React = require('react');
let BaseComponent = require('../../shared/base');

import Carousel from './carousel'

let client = require('../../../../sdk/client');
const { data } = require('jquery');

var slick;
if (typeof window !== 'undefined') {
    slick = require('slick-carousel');
}

class BannersHomeComponent extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            arrBanners: [],
            strCookieAddressId: ""
        }
        this.arrAllBanners = [];
    }

    //---------------------------------------------------------------------------------------------------------
    componentDidMount() {
        let self = this;
        let customerType = 'Default';
        if (self.props.user) {
            customerType = 'B2B';
            const customFields = self.props.user.CustomFields;
            const userType = customFields.find(cf => cf.Name === 'Tipo de Usuario');
            if (userType &&
                userType['Values'] &&
                userType['Values'][0] &&
                userType['Values'][0] === 'B2C'
            ) {
                customerType = 'B2C';
            }
        }
        client.Banners.getBanners().then((response) => {
            response = response.filter((res) => res.customer_type === customerType);
           //                                                   //Escuchar modificacion en direccion de usuario
           //                                                   // evento lo dispara el que hace el cambio 
            $(document).on('address-region-attribute-changed', function() {
                    setTimeout(
                        function(){
                            //console.log('ADDRESS CHANGED GO TO TRYING RECONFIGURE BANNER ');
                            self.addressChanged();
                    });
            });

            //                                                  //Almacenar todos los banners
            this.arrAllBanners = this.ordenarBanners(response);
            this.filtroActivoSeccion("Home");
            this.setState({
                arrBanners: this.arrAllBanners
            }, () => {
                self.tryToLoadRegionBanners();
            });
        },
        (error) => {
            console.log("Error DidMount")
        });
    }
   //---------------------------------------------------------------------------------------------------------
    ordenarBanners(
        arrBanners_I
        )
    {
        let newArrBanners = arrBanners_I;
        newArrBanners.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));
        return newArrBanners;
    }
   //---------------------------------------------------------------------------------------------------------
    filtroActivoSeccion(seccion){
        let newArrBanners = [];
        let arrAux = this.arrAllBanners;
        for (let i = 0; i < arrAux.length; i++) {
            let bannerSection = arrAux[i].section.replace(/\s/g, '')
            let isActive = (arrAux[i].active == "Si");
            if (
                 (bannerSection == seccion) &&
                 (isActive)
                ){
                newArrBanners.push(arrAux[i]);
            }        
        }
        newArrBanners.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));
        let self = this;
        this.setState({
            arrBanners: newArrBanners
        }, () => {
            self.arrAllBanners = newArrBanners;
        });
    }

   //-----------------------------------------------------------------------------------------------------------
    filtroRegion(
        //                                                         // The strCurrentRegion_I is lower case always
        strCurrentRegion_I
    )
    {
        let newArrBanners = []
        for (let i = 0; i < this.arrAllBanners.length; i++) {
            //Empty regions means that could display the banner in any region
            if (
                this.arrAllBanners[i].regions == ""
                )
            {
                newArrBanners.push(this.arrAllBanners[i]);
            }
            else
            {
                let arrRegions = this.arrAllBanners[i].regions.split(",");
                for (let j = 0; j < arrRegions.length; j++) {
                    let region = arrRegions[j].toLowerCase();                
                    if (region == strCurrentRegion_I){
                        newArrBanners.push(this.arrAllBanners[i]);
                        break;
                    }           
                }
            }
        }
        newArrBanners.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));
        //                                                   //Detecta cambio de Banners, depende esten ordenados igual
        if(JSON.stringify(this.state.arrBanners) != JSON.stringify(newArrBanners)) {
            //console.log("filtroRegion BodyBanner changing state...");
            this.setState({
                arrBanners: newArrBanners
            });
        } else {
            //console.log("filtroRegion BodyBanner no change detected...")
        }
    }

   //---------------------------------------------------------------------------------------------------------
    strGetCurrentRegion()
    {
        let currentRegion = document.getElementById('address-name').getAttribute('billing-address-region');
        if(currentRegion == null){
            currentRegion = "";
        }
        return currentRegion;
    }
   //---------------------------------------------------------------------------------------------------------
   tryToLoadRegionBanners(){
        if (
            this.boolAddressStuffWasLoaded()
            )
        {
            this.addressChanged();
        }
    }
    //---------------------------------------------------------------------------------------------------------
    addressChanged() {
        var addressId = $('#address-name').attr('addressid');
            let self = this;
            this.setState({strCookieAddressId:addressId}, () => {
                let currentRegion = self.strGetCurrentRegion();
                self.filtroRegion(currentRegion.toLowerCase());
            });        
    }
   //---------------------------------------------------------------------------------------------------------
    boolAddressStuffWasLoaded(){
        let boolAddressStuffWasLoaded = false;
        var addressId = document.getElementById("address-name").getAttribute("addressid");
        var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");
        if (
            addressId != null && addressId != "" && depotId != null && depotId != ""
            )
        {
            this.setState({strCookieAddressId:addressId});
            boolAddressStuffWasLoaded = true;
        }
        return boolAddressStuffWasLoaded;
    }

    render() {
        return (
            <section className="carousel" id="carousel-home">
              <Carousel data={this.state.arrBanners} />
            </section>
        );
    }
}

module.exports = BannersHomeComponent;